<template>
  <sc-render :fields="fields" :emptyMessage="$t('NO_DATA_SOURCE_EXIST')">
    <div v-if="hasFieldsValue" class="editorial-container" :class="{'theme-black': isDarkTheme}">
      <sc-text tag="h2"
               class="title"
               :field="fields.title"
               :class="{'title-desktop-center': isDesktopCenter, 'title-mobile-center': isMobileCenter}"/>
      <sc-rich-text tag="div"
                    class="description"
                    :field="fields.description"
      />
      <editorial-cta :fields="fields" />
    </div>
  </sc-render>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { Text, RichText } from '@sitecore-jss/sitecore-jss-vue'
import get from '~/helpers/get'
import ScRender from '../sc-render'
import EditorialCta from '../editorial-cta'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')
const { mapGetters: mapEnvGetters } = createNamespacedHelpers('ui/environment')

export default {
  name: 'EditorialBodyThree',
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    ScRender,
    ScText: Text,
    ScRichText: RichText,
    EditorialCta
  },
  computed: {
    ...mapJssGetters(['isEditMode']),
    ...mapEnvGetters(['isDarkTheme']),

    hasTitle () {
      return !!(get(this.fields, ['title']))
    },
    hasDescription () {
      return !!(get(this.fields, ['description']))
    },
    hasFieldsValue () {
      return !!(this.isEditMode || this.hasTitle || this.hasDescription)
    },
    isDesktopCenter () {
      return get(this.fields, ['titleAlignmentDesktop', 'value']) === 'Center'
    },
    isMobileCenter () {
      return get(this.fields, ['titleAlignmentMobile', 'value']) === 'Center'
    }
  }
}
</script>

<style lang="scss" scoped>

.editorial-container {
  padding:0 $space-050;
  margin-bottom: $space-090;

  @include tablet() {
    padding: 0 $space-060;
    margin-bottom: $space-100;
    max-width: 70%
  }

  .title {
    @include font('090');
    margin-bottom: $space-060;

    @include tablet () {
      @include font('100');
    }
  }

  .description {
    @include font('050');

    @include tablet () {
      @include font('070');
    }
  }

 .title-desktop-center {
   @include tablet () {
     text-align: center;
   }
  }

 .title-mobile-center {
   @include mobile() {
     text-align: center;
   }
  }
}

.theme-black {
  color: $color-white;
  max-width: 100%;

  .title {
    color: $color-white;
  }

  @include tablet() {
    .title {
      max-width: 70%
    }

    .description {
      max-width: 70%
    }
  }
}
</style>
